export const submitSanitizer = params => {
  return {
    firstName: params.names,
    lastName: params.lastNames,
    email: params.email,
    mobile: params.mobile,
    typeOfIdentification: params.identificationType,
    identification: params.identification
  };
};
